import React from 'react'

import { DefaultClosingForm } from './DefaultClosingForm'
import { EventCancelledClosingForm } from './EventCancelledClosingForm'

import { useScriptFlowState } from '@/components/Event/NewScript/hooks/state/useScriptFlowState'
import { ScriptStepProps } from '@/types'

export const ClosingStep: React.FC<ScriptStepProps> = ({ event }) => {
  const { state, actions, currentEventIndex } = useScriptFlowState()
  const stepState = state.events[currentEventIndex ?? 0]
  const witnessIndex = state.events.length > 1 ? currentEventIndex : undefined

  return stepState.first_skipped_step ? (
    <EventCancelledClosingForm
      step={state.current_step}
      event={event}
      actions={actions}
      state={stepState}
      first_skipped_step={stepState.first_skipped_step}
      currentStepActions={state.steps[state.current_step].actions}
      currentEventIndex={currentEventIndex}
      witnessIndex={witnessIndex}
      scriptEventCount={state.events.length}
    />
  ) : (
    <DefaultClosingForm
      step={state.current_step}
      event={event}
      actions={actions}
      state={stepState}
      witnessIndex={witnessIndex}
      scriptEventCount={state.events.length}
    />
  )
}
